var _style, _circle, _g, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 26.7",
    style: {
      enableBackground: "new 0 0 27 26.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFB33F;stroke:#CCB242;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    className: "st0",
    cx: 13.4,
    cy: 13.6,
    r: 12.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_51",
    transform: "translate(1252.241 39.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_59",
    className: "st1",
    d: "M-1236.6-24.4c2.1-1.2,2.8-3.9,1.5-5.9c-1.2-2.1-3.9-2.8-5.9-1.5c-2.1,1.2-2.8,3.9-1.5,5.9 c0.4,0.6,0.9,1.2,1.5,1.5C-1239.6-24.9-1238-24.9-1236.6-24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_60",
    className: "st1",
    d: "M-1236.6-24.4c-1.4,0.8-3.1,0.8-4.4,0c-3.5,1.1-5.6,4.6-4.9,8.2c4.1,3.3,10.1,3.3,14.2,0 C-1231-19.8-1233.1-23.3-1236.6-24.4L-1236.6-24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_61",
    className: "st1",
    d: "M-1236.6-24.4c-1.4-0.5-3-0.5-4.4,0C-1239.7-23.6-1238-23.6-1236.6-24.4z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    className: "st0",
    cx: 13.4,
    cy: 13.6,
    r: 12.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,14.9L15.6,14.9c-0.1,0.1-0.2,0.1-0.4,0.2C15.4,15,15.5,14.9,15.6,14.9C15.6,14.9,15.6,14.9,15.6,14.9 c2.1-1.2,2.7-3.9,1.5-5.9c-1.2-2.1-3.9-2.8-5.9-1.5s-2.8,3.9-1.5,5.9c0.4,0.6,0.9,1.2,1.5,1.5c0.7-0.2,1.5-0.3,2.2-0.3 c-0.7,0-1.5,0.1-2.2,0.3c0,0,0,0,0,0c-3.5,1.1-5.6,4.6-4.9,8.2c4.1,3.3,10.1,3.3,14.2,0C21.2,19.5,19.1,16,15.6,14.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilIcon);
export default __webpack_public_path__ + "static/media/profil_icon.3bbbd6a39cde4cae97ab908d0dfb1632.svg";
export { ForwardRef as ReactComponent };